<template>
  <el-table
      v-loading="dataListLoading"
      :data="dataList"
      border
      style="width: 100%;"
      :max-height="maxHeight"
      :show-summary="true"
  >
    <el-table-column
        type="index"
        label="行号"
        header-align="center"
        align="center"
        width="50"
    ></el-table-column>
    <el-table-column
        prop="productCode"
        label="品番号"
        header-align="center"
        align="center"
        :show-overflow-tooltip="true"
    ></el-table-column>
    <el-table-column
        prop="productName"
        label="品名"
        header-align="center"
        align="center"
    ></el-table-column>
    <el-table-column
        prop="color"
        label="颜色"
        header-align="center"
        align="center"
    ></el-table-column>
    <el-table-column
        prop="size"
        label="尺寸"
        header-align="center"
        align="center"
    ></el-table-column>
    <el-table-column
        label="收入总合计"
        header-align="center"
        align="center"
    >


      <el-table-column
          prop="sendCount"
          label="当期发货数"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="saleCount"
          label="当期销售数"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="limitStorageCount"
          label="当期库存数量"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="saleAmount"
          label="销售额"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="carriagePrice"
          label="运费平摊单价"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="totalCarriagePrice"
          label="运费"
          header-align="center"
          align="center"
      ></el-table-column>
      <el-table-column
          prop="costPrice"
          label="成本单价"
          header-align="center"
          align="center"
      >
      </el-table-column>
      <el-table-column
          prop="totalCost"
          label="成本总金额"
          header-align="center"
          align="center"
      ></el-table-column>
    </el-table-column>
  </el-table>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'

export default {
  name: 'sell-report',
  mixins: [mixinViewModule],
  props:{
    params:{
      type:Object,
      default:()=>{
        return {}
      }
    }
  },
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/trade/sell/list',
        getDataListIsPage: false,
        activatedIsNeed: false,
      },
      maxHeight:500,
      dataForm: {
        beginDate: '',
        endDate: '',
      },
    }
  },
  watch:{
    params:{
      handler:function(newVal){
        if(!newVal.beginDate||!newVal.endDate){
          return
        }
        this.dataForm={
          ...newVal
        }
        this.getDataList()
      },
      immediate:true,
      deep:true
    }
  },
  mounted () {
    this.$nextTick(()=>{
      this.maxHeight=document.body.clientHeight-220
    })

  },
  methods:{
    refresh(){
      this.getDataList()
    }
  }
}
</script>

<style scoped>

</style>
